"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _format = _interopRequireDefault(require("date-fns/format"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Text = _interopRequireDefault(require("../Text"));

var _date = _interopRequireDefault(require("./date.proptypes"));

var _constant = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var DateContainer = _styledComponents.default.div.withConfig({
  displayName: "Date__DateContainer",
  componentId: "sc-183o81e-0"
})(["display:inline-block;& > *{font-size:", ";}"], function (_ref) {
  var theme = _ref.theme,
      size = _ref.size;
  return theme.fontSize[size];
});

var AirAsiaDate = function AirAsiaDate(_ref2) {
  var theme = _ref2.theme,
      size = _ref2.size,
      color = _ref2.color,
      accessible = _ref2.accessible,
      customProperties = _ref2.customProperties,
      date = _ref2.date,
      format = _ref2.format,
      allowLocaleFormat = _ref2.allowLocaleFormat,
      locale = _ref2.locale,
      localeConfig = _ref2.localeConfig;

  var formatDate = function formatDate(inputDate, inputFormat) {
    if (!allowLocaleFormat) {
      return (0, _format.default)(new Date(inputDate), inputFormat);
    }

    if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
      var localeToUse = locale || navigator.userLanguage || navigator.language || _constant.DEFAULT_LOCALE;
      var localeDate = '';

      try {
        localeDate = new Intl.DateTimeFormat(localeToUse, localeConfig).format(inputDate);
      } catch (_unused) {
        localeDate = new Intl.DateTimeFormat(navigator.userLanguage || navigator.language || _constant.DEFAULT_LOCALE, localeConfig).format(inputDate);
      }

      return localeDate;
    }

    return '';
  };

  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(DateContainer, {
      size: size,
      theme: themeContext
    }, /*#__PURE__*/_react.default.createElement(_Text.default, {
      color: color,
      accessible: accessible,
      customProperties: customProperties
    }, formatDate(date, format)));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

AirAsiaDate.propTypes = _date.default.PropTypes;
AirAsiaDate.defaultProps = _date.default.DefaultProps;
var _default = AirAsiaDate;
exports.default = _default;